/** Versão da aplicação — REACT_APP_VERSAO do .env (dev/prod), exposta ao bundle pelo CRA */

export function getVersaoApp() {
  const versao = String(process.env.REACT_APP_VERSAO || "").trim();
  return versao || "—";
}



export function getAmbienteExecucao() {

  const nodeEnv = String(process.env.NODE_ENV || "").trim().toLowerCase();

  if (nodeEnv === "production" || nodeEnv === "development") return nodeEnv;

  return nodeEnv || "—";

}



let versaoLogada = false;



/** Log único no console (evita duplicata do React StrictMode em dev). */

export function logVersaoAppNoConsole() {

  if (versaoLogada) return;

  versaoLogada = true;



  const versao = getVersaoApp();

  const ambiente = getAmbienteExecucao();

  console.log(`[GDoc] Versão: ${versao} — ${ambiente}`);

}


